
export default {
  data() {
    return {
      inView: false,
      success: false,
      recaptchaToken: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$renderRecaptcha("contact-recaptcha");
      }, 500);
    });
  },
  methods: {
    async handleSubmit() {
      if (!this.recaptchaToken) {
        this.$toast.error(this.$t("contactForm.recaptchaRequired"));
        return;
      }

      const isValid = await this.$verifyRecaptcha(this.recaptchaToken);
      if (!isValid) {
        this.$toast.error(this.$t("contactForm.recaptchaInvalid"));
        this.$resetRecaptcha("contact-recaptcha");
        return;
      }

      this.$refs.form.submit();
    },
  },
};
